<template>
  <div class="step-two">
    <div class="step__section">
      <div class="step-two__title">Тренер сборной</div>
      <div class="step-two__image">
        <div class="step-two__image-wrapper">
          <div class="step-two__image-border">
            <img
              v-if="asideDataClone.stepData.step2.coachImageBlob"
              :src="asideDataClone.stepData.step2.coachImageBlob"
            />
            <div v-else class="step-two__image-icon">
              <UserIcon />
            </div>
          </div>
          <ui-file
            v-if="!asideDataClone.stepData.step2.coachImageBlob"
            data-name="logo"
            medium-files
            only-images
            is-custom
            :multiple="false"
            @getFiles="loadLogo"
          >
            <div class="step-two__image-update -pointer-">
              <camera-icon />
            </div>
          </ui-file>
        </div>
        <div class="step-two__image-controls">
          <div class="step-two__image-desc">
            Загрузи фото тренера сборной формата <b>300х340.</b>
          </div>
          <template v-if="asideDataClone.stepData.step2.coachImageBlob">
            <div class="step-two__image-control step-two__image-control-edit" @click="onLogoEdit">
              <icon icon="ui-scale" />
              Редактировать
            </div>
            <div
              class="step-two__image-control step-two__image-control-delete"
              @click="onLogoDelete"
            >
              <icon icon="delete" />
              Удалить
            </div>
          </template>
        </div>
      </div>
      <coach-info v-if="facultyCoachList.length === 0" :options="coachList" @change="setCoach" />
      <coach-info
        v-for="(coach, coachIndex) in facultyCoachList"
        :key="coachIndex"
        :index="coachIndex"
        :coach="coach"
        :options="coachList"
        :coach-list="facultyCoachList"
        @change="setCoach"
        @addCoach="addCoach"
        @deleteCoach="deleteCoach"
      />
      <br />
      <ui-modal :value="showCropper" :show-footer="false" @close="onCropperClose">
        <div class="step-two__modal">
          <h3 class="step-two__modal-header">Изображение логотипа</h3>
          <cropper
            class="step-two__modal-cropper"
            :src="asideDataClone.stepData.step2.coachImageBlob"
            :stencil-component="$options.components.RectangleStencil"
            @change="onImageCrop"
          />
          <div class="step-two__modal-footer">
            <ui-button color="primary-invert" @click="onCropperClose"> Отмена </ui-button>
            <ui-button @click="onCropperAccept"> Загрузить </ui-button>
          </div>
        </div>
      </ui-modal>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import UserIcon from '@/components/Icons/UserIcon';
import CoachInfo from './components/CoachInfo';
import CameraIcon from '@/components/Icons/CameraIcon';

export default {
  components: {
    CameraIcon,
    Cropper,
    UserIcon,
    CoachInfo
  },
  props: {
    asideData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      asideDataClone: {},
      file: '',
      showCropper: false,
      croppedImage: undefined
    };
  },
  computed: {
    coachList() {
      return this.asideData.stepData.options.coaches;
    },
    facultyCoachList() {
      return this.asideData.stepData.step2.coachList;
    }
  },
  created() {
    this.asideDataClone = _.cloneDeep(this.asideData);
    this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
    this.$emit('update:asideData', this.asideDataClone);
  },
  methods: {
    dataValid(stepData) {
      return !!(
        stepData.coachList.length &&
        stepData.coachList?.every(c => !!c.id) &&
        (stepData.coachImageBlob || stepData.coachImageFileObject)
      );
    },
    loadLogo(event) {
      this.asideDataClone.stepData.step2.coachImageBlob = URL.createObjectURL(event.file);
      this.asideDataClone.stepData.step2.coachImageFileObject = event.file;
      this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
      this.$emit('update:asideData', this.asideDataClone);
    },
    onLogoEdit() {
      this.openCropper();
    },
    onLogoDelete() {
      this.asideDataClone.stepData.step2.coachImageBlob = undefined;
      this.asideDataClone.stepData.step2.coachImageFileObject = undefined;
      this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
      this.$emit('update:asideData', this.asideDataClone);
      this.showCropper = false;
    },
    openCropper() {
      this.showCropper = true;
    },
    onCropperClose() {
      this.showCropper = false;
    },
    onCropperAccept() {
      this.showCropper = false;
      this.asideDataClone.stepData.step2.coachImageBlob = this.croppedImage;
      this.asideDataClone.stepData.step2.coachImageFileObject = this.file;
      this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
      this.$emit('update:asideData', this.asideDataClone);
    },
    onImageCrop(event) {
      this.croppedImage = event.canvas.toDataURL();
      event.canvas.toBlob(blob => {
        this.file = blob;
      });
    },
    async setCoach({ value, index }) {
      if (this.facultyCoachList.length === 0) {
        this.asideDataClone.stepData.step2.coachList.push(value);
      } else {
        this.$set(this.asideDataClone.stepData.step2.coachList, index, value);
      }
      this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
      this.$emit('update:asideData', this.asideDataClone);
    },
    addCoach() {
      this.asideDataClone.stepData.step2.coachList.push({
        id: 0,
        value: '',
        achievementsList: []
      });
      this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
      this.$emit('update:asideData', this.asideDataClone);
    },
    deleteCoach(index) {
      this.asideDataClone.stepData.step2.coachList.splice(index, 1);
      this.asideDataClone.isValid = this.dataValid(this.asideDataClone.stepData.step2);
      this.$emit('update:asideData', this.asideDataClone);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.step-two {
  &__title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #2b2d34;
    margin-bottom: 16px;
  }

  &__image {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &-controls {
      display: flex;
      flex-direction: column;
    }

    &-desc {
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: -0.3px;
      color: #76767b;
      margin-bottom: 16px;

      b {
        font-weight: 500;
      }
    }

    &-control {
      margin-bottom: 10px;
      cursor: pointer;
      @extend %text-400-14;
      display: flex;

      &-edit svg {
        fill: $ui-light-grey-4-5-contrast;
        height: 16px;
        width: 16px;
      }

      &-delete svg {
        fill: $ui-red;
        height: 16px;
        width: 16px;
      }

      svg {
        margin-right: 8px;
      }
    }

    &-wrapper {
      position: relative;
      @include size(140px, 200px);
      min-width: 140px;
      margin-top: 4px;
      margin-right: 20px;
    }

    &-border {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      background: #f7f7fb;
      border-radius: 8px;
    }

    &-icon {
      @include size(40px);
      background: $main-bg;
    }

    &-update {
      @include size(30px);
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #d8defd;
      padding: 2px;
      border-radius: 4px;
      border: 2px solid #f7f7fb;
      bottom: 0;
      right: 0;
      box-shadow: 0 6px 8px 0 #1b23631a;
    }
  }

  &__modal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include uiFont;

    &-header {
      @extend %text-700-18;
    }

    &-cropper {
      height: 300px;
      margin-top: 20px;
    }

    &-footer {
      display: flex;
      flex-direction: row;
      margin-top: 20px;

      button {
        min-width: unset;
        flex-grow: 1;

        &:first-child {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
